const conditionMonitoring = {
    template: '<condition-monitoring-view></condition-monitoring-view>'
};

angular
    .module('condition-monitoring.module', ['ui.router'])
    .component('conditionMonitoring', conditionMonitoring)
    .config(function ($stateProvider) {
        $stateProvider
            .state('condition-monitoring', {
                url: '/condition-monitoring',
                component: 'conditionMonitoring',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ASSET_STATUS_LIST'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                },
            });
    });